module.exports = __webpack_public_path__ + "img/icon_sm_dbrkqr.301a06f1.png";